module.exports = __webpack_public_path__ + "static/img/back.aa1606e3.png";